var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    fill: "#0350a5",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.8,25.4l-8.6-12c-1.1-1.5-2.8-2.4-4.6-2.4H57.8H42.2H21.4c-1.8,0-3.6,0.9-4.6,2.4l-8.6,12l0,0C8.1,25.6,8,25.8,8,26   v58.8c0,2.9,2.3,5.2,5.2,5.2h73.5c2.9,0,5.2-2.4,5.2-5.2V26C92,25.8,91.9,25.6,91.8,25.4L91.8,25.4z M78.6,13c1.2,0,2.3,0.6,3,1.5   L89.1,25H61.8l-3.4-12H78.6z M43.8,13h12.5L60,26.1v18c0,0,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1,0L50,38.9l-9.8,5.4c0,0-0.1,0-0.1,0   c-0.1,0-0.1-0.1-0.1-0.1v-18L43.8,13z M18.4,14.5c0.7-1,1.8-1.5,3-1.5h20.3l-3.4,12H10.9L18.4,14.5z M90,84.8   c0,1.8-1.5,3.2-3.2,3.2H13.2c-1.8,0-3.2-1.5-3.2-3.2V27h28v17.1c0,0.8,0.4,1.4,1,1.8c0.3,0.2,0.7,0.3,1.1,0.3c0.3,0,0.7-0.1,1-0.3   l8.9-4.8l8.9,4.8c0.7,0.4,1.4,0.3,2.1,0c0.6-0.4,1-1.1,1-1.8V27h28V84.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 25,
    width: 16,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBlue);
export default __webpack_public_path__ + "static/media/product_blue.71a67e8dd96aa8607858423665227be8.svg";
export { ForwardRef as ReactComponent };